<app-authorised-top-nav></app-authorised-top-nav>
<div class="wrapper">
  <app-authorised-side-nav></app-authorised-side-nav>
  <app-page-content></app-page-content>
</div>

<!-- 
<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="example-toolbar">
    <img class="hamburger" src="assets/images/menu.svg" (click)="snav.toggle()">
    <img class="appLogo" src="assets/kc-logo.png">
  </mat-toolbar>
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56" [opened]="mobileQuery.matches ? 'false' : 'true'">
      <mat-nav-list (click)="mobileQuery.matches ? snav.toggle():''">
        <app-authorised-side-nav></app-authorised-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div> -->